import { render, staticRenderFns } from "./cards-tables.vue?vue&type=template&id=0b334650&scoped=true"
import script from "./cards-tables.vue?vue&type=script&lang=js"
export * from "./cards-tables.vue?vue&type=script&lang=js"
import style0 from "./cards-tables.vue?vue&type=style&index=0&id=0b334650&prod&lang=css"
import style1 from "./cards-tables.vue?vue&type=style&index=1&id=0b334650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b334650",
  null
  
)

export default component.exports